import { useState } from 'react';
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../utils/supabase';
import { useAuth } from '../lib/auth';
import AuthLayout, { errorBox, inputClass, noticeBox, primaryButton } from './AuthLayout';
import GoogleButton, { OrDivider } from './GoogleButton';

export default function Login() {
  const { session } = useAuth();
  const [params] = useSearchParams();
  const next = params.get('next') || '/';
  const navigate = useNavigate();
  const [email, setEmail] = useState(() => params.get('email') || '');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');

  if (session) return <Navigate to={next} replace />;

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error } = await supabase.auth.signInWithPassword({ email: email.trim(), password });
    setLoading(false);
    if (error) setError(error.message);
    else navigate(next, { replace: true });
  };

  const handleReset = async () => {
    setError('');
    setNotice('');
    if (!email.trim()) {
      setError('Enter your email first, then choose "Forgot password".');
      return;
    }
    const { error } = await supabase.auth.resetPasswordForEmail(email.trim(), {
      redirectTo: `${window.location.origin}/account/password`,
    });
    if (error) setError(error.message);
    else setNotice('Check your email for a link to set a new password.');
  };

  return (
    <AuthLayout title="Sign in" subtitle="Digital business cards">
      <GoogleButton redirectPath={next} />
      <OrDivider />
      <form onSubmit={handleLogin} className="space-y-4">
        <label className="block">
          <span className="block text-sm font-medium text-ink mb-1">Email</span>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputClass}
            placeholder="you@company.com" autoComplete="email" required disabled={loading} />
        </label>
        <label className="block">
          <span className="block text-sm font-medium text-ink mb-1">Password</span>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputClass}
            autoComplete="current-password" required disabled={loading} />
        </label>
        {error && <div className={errorBox}>{error}</div>}
        {notice && <div className={noticeBox}>{notice}</div>}
        <button type="submit" disabled={loading} className={primaryButton}>
          {loading ? 'Signing in...' : 'Sign in'}
        </button>
      </form>
      <div className="flex justify-between text-sm mt-6">
        <button onClick={handleReset} className="text-ink-muted hover:underline">Forgot password?</button>
        <Link to={`/signup${next !== '/' ? `?next=${encodeURIComponent(next)}` : ''}`} className="font-medium text-ink hover:underline">
          Create an account
        </Link>
      </div>
    </AuthLayout>
  );
}
